import { pathOr } from 'ramda'
import { compose, withProps } from 'recompose'

import withPartnerProps from 'components/HOCs/WithPartnerProps'
import withReferralProp from 'components/HOCs/WithReferralProp'
import { withFlowRouter } from 'utils/FlowProvider'

import { AddedProps, EnhancedNavProps, InnerProps, NavProps } from './types'

export const enhance = compose<EnhancedNavProps, NavProps>(
  withFlowRouter,
  withReferralProp,
  withPartnerProps,
  withProps<InnerProps, AddedProps>(({ partner, referral }) => {
    return {
      referralAmount: pathOr(null, ['reward_amounts', 'referree'], referral),
      partnerLogo: pathOr(null, ['org', 'logoTypeUrl'], partner),
    }
  }),
)
